import { useEffect, useState } from "react";
import { PolicyType } from "../../models/PolicyType";
import { Button, Form, Modal, Stack } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faSave } from "@fortawesome/free-solid-svg-icons";

type Props = {
  onHide: () => void;
  onSave?: (newPolicyType: PolicyType) => void;
  show: boolean;
  policyType?: PolicyType | null;
  title?: string;
};

export const ModalPolicyTypeForm = (props: Props) => {
  const [policyType, setPolicyType] = useState<PolicyType>({
    id: 0,
    policyDesc: "",
    isActive: true,
  });
  const [validated, setValidated] = useState(false);

  const loadPolicyType = async () => {
    setPolicyType({
      policyDesc: props.policyType?.policyDesc || "",
      isActive: props.policyType?.isActive || true,
    });
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setPolicyType({
      ...policyType,
      [name]: value,
    });
  };

  const handleOnSubmit = (event: any) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
    }

    policyType.id = props.policyType?.id;
    props.onSave!(policyType);
    setValidated(true);
  };

  const resetForm = () => {
    setPolicyType({
      policyDesc: "",
      isActive: false,
    });
    setValidated(false);
  };

  useEffect(() => {
    loadPolicyType();
  }, [props.policyType, props.show]);

  return (
    <Form validated={validated} noValidate>
      <Modal
        show={props.show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        onHide={props.onHide}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {props.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Stack gap={3}>
            <Form.Group>
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                maxLength={50}
                required={true}
                name="policyDesc"
                value={policyType.policyDesc}
                onChange={handleInputChange}
              />
            </Form.Group>
          </Stack>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              !props.policyType?.id! && resetForm();
              props.onHide();
            }}
          >
            <FontAwesomeIcon icon={faBan} style={{ paddingRight: "3px" }} />
            <span className="ms-2">Cancelar</span>
          </Button>
          <Button type="submit" variant="primary" onClick={handleOnSubmit}>
            <FontAwesomeIcon
              icon={faSave}
              style={{
                paddingRight: "3px",
              }}
            />
            <span className="ms-2">Guardar</span>
          </Button>
        </Modal.Footer>
      </Modal>
    </Form>
  );
};
